import * as nativeComponentAPI from '../../../../api/nativeComponentAPI'
import VisibleComponent from "./VisibleComponent";
import { OPERATE_COMPONENT_TYPE } from "../../../../common/enums/index";

export default class PlayerView extends VisibleComponent {
    constructor (...props) {
        const action = nativeComponentAPI.createWebview
        super(action, {}, ...props)
    }

}